import { FC, useCallback, useMemo } from "react";
import dayjs from "dayjs";
import { Field, Form } from "react-final-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  useToast,
  VStack,
  Image,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Container,
  Text,
  Grid,
  GridItem,
  Center,
  CircularProgress,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import {
  useGetTrip,
  useGetUser,
  useGetFavorite,
  useGetAchievment,
} from "../../hooks";
import {
  CustomInput,
  CustomCheckbox,
  CustomSelect,
} from "../../../customComponents/components";
import {
  destructure,
  favoriteColumn,
  fields,
  handleLink,
  isDisabled,
  tabs,
  tripFields,
  validate,
} from "../../helpers";
import { FuncButton } from "../../../customComponents/components/FuncButton";
import { PageHead } from "../../../home/components/PageHead";
import { CardsBlock } from "../../components/CardsBlock";
import { TableHead } from "../../../home/components/TableHead";
import {
  DonwloadComponent,
  DonwloadComponentNew,
} from "../../../customComponents/components/CustomInput/CustomInput";
import { useVehicleList } from "../../../vehicle/hooks";
import { useVehicleMarkList as usePromoStatusList } from "../../../promoStatus/hooks";

export const EditUser: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const toast = useToast();

  const {
    user,
    deleteUser,
    restoreUser,
    updateUser,
    updateUserData,
    userLoading,
    userDataLoading,
  } = useGetUser(id);

  const {
    username,
    deleted,
    disabled,
    email,
    phone,
    name,
    surname,
    thirdname,
    driver_experience,
    balance,
    security_check,
    birth_date,
    deposit_balance,
    passport_first_page,
    passport_second_page,
    driver_license_first_page,
    driver_license_second_page,
    selfie,
    user_id,
  }: any = user;

  const onSubmit = (values) => {
    const { user, userData } = values;
    Promise.all([
      updateUser({ id, ...user }),
      updateUserData({
        user_id: id,
        ...userData,
        birth_date: userData?.birth_date
          ? dayjs(userData.birth_date).format("MM/DD/YYYY")
          : "",
        // security_check: userData.security_check ? "1" : false,
      }),
    ]).then(() =>
      toast({
        title: "Успешно",
        description: "Данные сохранены",
        status: "success",
        duration: 4000,
        isClosable: true,
      })
    );
  };

  const API_URL = process.env.REACT_APP_API_URL;

  const { favoriteList, favoriteLoading } = useGetFavorite();
  const { tripList, tripLoading } = useGetTrip(id);
  const { received, unreceived, addAchievment } = useGetAchievment(id);
  const { vehiclesList } = useVehicleList();
  const promoStatusList = usePromoStatusList().vehicleMarkList;

  const favoriteListMemo = useMemo(() => {
    if (favoriteList?.length && vehiclesList?.length) {
      return vehiclesList.filter((v) => {
        if (favoriteList.find((f) => f.user_id == id && f.vehicle_id == v.id)) {
          return true;
        }
        return false;
      });
    }
    return [];
  }, [favoriteList, vehiclesList, id]);

  const handleRedirect = useCallback((href) => {
    navigate(href);
  }, []);

  const handleAddAchievment = (achievment_id) => {
    addAchievment({ user_id: id, achievment_id });
  };

  const promoStatusListCurrent = useMemo(() => {
    const promoStatusListReversed = [...promoStatusList];
    return promoStatusListReversed.find((p) => balance >= p.bonus_cost);
  }, [promoStatusList, balance]);
  // console.log(userLoading, userDataLoading, favoriteListMemo);
  // console.log("promoStatusListCurrent", promoStatusListCurrent);
  // console.log("passport_first_page", passport_first_page);
  console.log('recieved', received);
  return (
    <PageHead
      breadCrumbs={
        <Breadcrumb
          spacing="8px"
          separator={<ChevronRightIcon color="gray.500" />}
        >
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/">
              Клиенты
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink href="#">
              <Text color="#A6A8AE">{username}</Text>
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
      }
      // onClick={() => handleRedirect(`/travel?user_id=${id}`)}
      // linkLabel="Список поездок 123"
    >
      <Divider marginTop={"20px"} marginBottom={"20px"} />
      <Tabs isFitted>
        <TabList>
          {tabs.map(({ id, label }) => (
            <Tab
              key={id}
              fontWeight="700"
              _selected={{ color: "#FFFFFF", bg: "#282C35" }}
            >
              {label}
            </Tab>
          ))}
        </TabList>

        <TabPanels borderTop="1px solid #282C35" paddingTop="43px">
          <TabPanel padding="0">
            {userLoading || userDataLoading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : user ? (
              <Form
                mutators={{
                  setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value);
                  },
                }}
                onSubmit={onSubmit}
                validate={validate}
                initialValues={{
                  user: {
                    phone,
                    email,
                    username,
                    disabled: disabled === "1" ? true : false,
                  },
                  userData: {
                    name,
                    surname,
                    thirdname: thirdname === "null" ? "" : thirdname,
                    driver_experience,
                    balance,
                    security_check,
                    birth_date: birth_date
                      ? dayjs(birth_date, "MM/DD/YYYY").format("YYYY-MM-DD")
                      : "",
                    deposit_balance,
                    passport_second_page,
                    driver_license_first_page,
                    passport_first_page,
                    driver_license_second_page,
                    selfie,
                  },
                }}
                render={({ form, handleSubmit, values }) => {
                  console.log("values", values);
                  //@ts-ignore
                  window.form = form;
                  return (
                    <Box>
                      <CardsBlock
                        title="Данные пользователя"
                        user_id={user_id}
                        isUnique
                      >
                        <Grid templateColumns="repeat(3, 2fr)" gap={6}>
                          {fields.first_block.map(
                            ({
                              id,
                              name,
                              placeholder,
                              label,
                              type,
                              pattern,
                            }) => (
                              <GridItem w="100%" h="20" gap={12}>
                                {type === "date" ? (
                                  <Field
                                    key={id}
                                    name={name}
                                    placeholder={placeholder}
                                    label={label}
                                    pattern={pattern}
                                    component={CustomInput}
                                    type={type}
                                  />
                                ) : type === "checkbox" ? (
                                  <Field
                                    key={id}
                                    name={name}
                                    placeholder={placeholder}
                                    label={label}
                                    component={CustomCheckbox}
                                    type={type}
                                  />
                                ) : type === "select" ? (
                                  <Field
                                    key={id}
                                    name={name}
                                    placeholder={placeholder}
                                    label={label}
                                    component={CustomSelect}
                                    type={type}
                                    options={[
                                      {
                                        id: "pending",
                                        label: "Ожидает",
                                      },
                                      {
                                        id: "1",
                                        label: "Пройдена",
                                      },
                                      {
                                        id: "blocked",
                                        label: "Заблокирован",
                                      },
                                    ]}
                                  />
                                ) : (
                                  <Field
                                    key={id}
                                    name={name}
                                    placeholder={placeholder}
                                    label={label}
                                    component={CustomInput}
                                    type={type}
                                  />
                                )}
                              </GridItem>
                            )
                          )}
                        </Grid>
                      </CardsBlock>

                      <Divider marginTop={"20px"} marginBottom={"20px"} />
                      <CardsBlock title="Депозит">
                        <Flex
                          alignContent={"center"}
                          justifyContent={"flex-start"}
                          gap={"20px"}
                        >
                          {fields.second_block.map(
                            ({ id, name, placeholder, label, type }) => (
                              <Box maxWidth={"1000px"}>
                                {" "}
                                <Field
                                  key={id}
                                  name={name}
                                  placeholder={placeholder}
                                  label={label}
                                  component={CustomInput}
                                  type={type}
                                />
                              </Box>
                            )
                          )}
                        </Flex>
                      </CardsBlock>

                      <Divider marginTop={"20px"} marginBottom={"20px"} />

                      <CardsBlock
                        title="Документы"
                        onClick={handleSubmit}
                        isSubmitting
                      >
                        <Flex
                          alignContent={"center"}
                          justifyContent={"flex-start"}
                          flexWrap={"wrap"}
                          gap={"20px"}
                        >
                          {fields.documents.first_row.map(
                            ({ id, name, label, area }) => {
                              let nameS = name.split(".")[1];
                              console.log(
                                "name = ",
                                name,
                                values,
                                `${API_URL}/${values.userData[nameS]}`
                              );
                              return (
                                <DonwloadComponentNew
                                  label={label}
                                  intialPreview={values.userData[nameS]}
                                  // intialPreview={`${API_URL}/${values[name]}`}
                                  name={name}
                                  multiple={false}
                                  fullwidth={false}
                                />
                                // <GridItem area={area}>
                                //   <VStack align="flex-start" key={id}>
                                //   </VStack>
                                // </GridItem>
                              );
                            }
                          )}
                        </Flex>
                      </CardsBlock>
                      <Divider marginTop={"20px"} marginBottom={"20px"} />
                    </Box>
                  );
                }}
              />
            ) : (
              <Container>
                <Text fontSize="xl" textAlign={"center"}>
                  Данные отсутствуют
                </Text>
              </Container>
            )}
          </TabPanel>
          <TabPanel>
            {favoriteLoading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : favoriteListMemo.length ? (
              <TableHead column={favoriteColumn}>
                {favoriteListMemo.map(({ id, title }) => (
                  <Tr key={id}>
                    <Td>{id}</Td>
                    <Td>{title}</Td>
                  </Tr>
                ))}
              </TableHead>
            ) : (
              <Container>
                <Text fontSize="xl" textAlign={"center"}>
                  Автомобили отсутствуют
                </Text>
              </Container>
            )}
          </TabPanel>
          <TabPanel>
            <FuncButton
              onClick={() => {
                navigate(`/travel_set?user_id=${id}`);
              }}
            >
              Создать поездку
            </FuncButton>
            <Divider marginTop={"20px"} marginBottom={"20px"} />
            {tripLoading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : tripList ? (
              <TableHead column={tripFields}>
                {tripList.map(
                  ({
                    id,
                    date_start,
                    date_end,
                    vehicle_title,
                    user_full_name,
                    price,
                  }) => (
                    <Tr key={id}>
                      <Td>{id}</Td>
                      <Td>{`${date_start} - ${date_end}`}</Td>
                      <Td>{vehicle_title}</Td>
                      <Td>{user_full_name}</Td>
                      <Td>{price}</Td>
                      <Td>
                        <FuncButton
                          onClick={() => {
                            navigate(`/travel_set/${id}`);
                          }}
                        >
                          Перейти к поездке
                        </FuncButton>
                      </Td>
                    </Tr>
                  )
                )}
              </TableHead>
            ) : (
              <Container>
                <Text fontSize="xl">Поездки отсутствуют</Text>
              </Container>
            )}
          </TabPanel>
          <TabPanel>
            <Flex justify="space-between">
              <Heading size={"md"}>
                Статус: {promoStatusListCurrent?.title || ""}
              </Heading>
            </Flex>
            <div style={{ marginTop: 20, marginBottom: 20 }} />
            <Heading size={"md"}>Награды</Heading>
            <div style={{ marginTop: 20, marginBottom: 20 }} />
            <Tabs>
              <TabList>
                <Tab>Полученные</Tab>
                <Tab>Не полученные</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  {received.length ? (
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>ID</Th>
                          <Th>Название</Th>
                          <Th>Статус</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {received.map(({ id, title }) => (
                          <Tr key={id}>
                            <Td>{id}</Td>
                            <Td>{title}</Td>
                            <Td>
                              <Button disabled>Получено</Button>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  ) : (
                    <Container>
                      <Text fontSize="xl" textAlign={"center"}>
                        Данные отсутствуют
                      </Text>
                    </Container>
                  )}
                </TabPanel>
                <TabPanel>
                  {unreceived.length ? (
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>ID</Th>
                          <Th>Название</Th>
                          <Th>Статус</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {unreceived.map(({ id, title }) => (
                          <Tr key={id}>
                            <Td>{id}</Td>
                            <Td>{title}</Td>
                            <Td>
                              <Button onClick={() => handleAddAchievment(id)}>
                                Получить
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  ) : (
                    <Container>
                      <Text fontSize="xl" textAlign={"center"}>
                        Данные отсутствуют
                      </Text>
                    </Container>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </PageHead>
  );
};
